import { useLoading } from './ProgressContext';

const LHHCApiService = () => {
  // Create an Axios instance
  const { axiosInstance } = useLoading(); // Use the Axios instance from context

  const api = axiosInstance;

  // Define the service methods
  const addHc = async (data) => {
    try {
      const response = await api.post('/api/HC/AddHc', data);
      return response.data;
    } catch (error) {
      console.error('Error adding HC:', error);
      throw error;
    }
  };

  const getHc = async (id) => {
    try {
      const response = await api.get(`/api/HC/GetHc/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting HC:', error);
      throw error;
    }
  };

  const addMatch = async (data) => {
    try {
      const response = await api.post('/api/HC/AddMatch', data);
      return response.data;
    } catch (error) {
      console.error('Error adding match:', error);
      throw error;
    }
  };

  const getMatch = async (id) => {
    try {
      const response = await api.get(`/api/HC/GetMatch/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting match:', error);
      throw error;
    }
  };

  const list = async () => {
    try {
      const response = await api.get(`/api/HC/List`);
      return response.data;
    } catch (error) {
      console.error('Error listing matches:', error);
      throw error;
    }
  };

  // Return all methods as an object
  return {
    addHc,
    getHc,
    addMatch,
    getMatch,
    list,
  };
};

export default LHHCApiService;
